import type { CrashPresentation } from './SkierEntity';
import { AvalancheEffect } from './AvalancheEffect';
import { SnowballEffect } from './SnowballEffect';
import { SnowSlabEffect } from './SnowSlabEffect';
import { CliffEffect } from './CliffEffect';

export class CrashEffectController {
  private avalanche: AvalancheEffect;
  private snowball: SnowballEffect;
  private snowSlab: SnowSlabEffect;
  private cliff: CliffEffect;
  private selected: CrashPresentation = 'explosion';

  constructor(width: number, height: number) {
    this.avalanche = new AvalancheEffect(width, height);
    this.snowball = new SnowballEffect(width, height);
    this.snowSlab = new SnowSlabEffect(width, height);
    this.cliff = new CliffEffect(width, height);
  }

  begin(presentation: CrashPresentation) {
    this.reset();
    this.selected = presentation;
    if (presentation === 'avalanche') this.avalanche.begin();
    if (presentation === 'snowball') this.snowball.begin();
    if (presentation === 'snow_slab') this.snowSlab.begin();
    if (presentation === 'cliff') this.cliff.begin();
  }

  reset() {
    this.avalanche.reset();
    this.snowball.reset();
    this.snowSlab.reset();
    this.cliff.reset();
    this.selected = 'explosion';
  }

  update(dtMs: number) {
    if (this.selected === 'avalanche') this.avalanche.update(dtMs);
    if (this.selected === 'snowball') this.snowball.update(dtMs);
    if (this.selected === 'snow_slab') this.snowSlab.update(dtMs);
    if (this.selected === 'cliff') this.cliff.update(dtMs);
  }

  shouldScrollWorld() {
    return this.selected === 'cliff' && this.cliff.shouldScrollWorld();
  }

  drawUnder(ctx: CanvasRenderingContext2D) {
    if (this.selected === 'snow_slab') this.snowSlab.drawUnder(ctx);
    if (this.selected === 'cliff') this.cliff.drawUnder(ctx);
  }

  drawOver(ctx: CanvasRenderingContext2D) {
    if (this.selected === 'avalanche') this.avalanche.draw(ctx);
    if (this.selected === 'snowball') this.snowball.draw(ctx);
    if (this.selected === 'snow_slab') this.snowSlab.drawOver(ctx);
    if (this.selected === 'cliff') this.cliff.drawOver(ctx);
  }
}
